import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  cart: (props: any) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: props.matches ? 430 : "100vw",
    height: "100%",
    padding: props.matches ? "2rem" : "1rem",
  }),
  cartItems: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  cartItem: {
    position: "relative",
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.snowColor}`,
    },
  },
  loadingContainer: (props: any) => ({
    display: props.processing ? "flex" : "none",
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  }),
  innerCartItem: (props: any) => ({
    opacity: props.processing ? 0 : 1,
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    paddingBottom: "1rem",
  }),
  image: (props: any) => ({
    minWidth: "7rem",
    maxWidth: "7rem",
    minHeight: "7rem",
    maxHeight: "7rem",
    background: `no-repeat center/100% url(${props.image})`,
  }),
  noImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.snowColor,
    minWidth: "7rem",
    maxWidth: "7rem",
    minHeight: "7rem",
    maxHeight: "7rem",
  },
  cartInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "0.2rem",
    fontSize: "0.8rem",
  },
  brand: {
    fontSize: "0.9rem",
  },
  name: {
    fontSize: "0.9rem",
    textTransform: "capitalize",
  },
  option: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    columnGap: "0.3rem",
    textTransform: "capitalize",
  },
  quantity: {
    fontSize: "0.8rem",
    textTransform: "uppercase",
  },
  removeBtn: {
    width: "max-content",
    padding: 0,
    background: "none",
    border: "none",
    color: theme.lightPinkColor,
    fontFamily: theme.fontFamilyArchivo,
    fontSize: "1rem",
    cursor: "pointer",
    textDecoration: "underline",
  },
  lowerSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: "1rem",
    borderTop: `1px solid ${theme.snowColor}`,
  },
  total: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalText: {},
  processToCheckoutBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3rem",
    marginTop: "1rem",
    border: "none",
    borderRadius: "8px",
    color: theme.whiteColor,
    background: `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: "uppercase",
    textDecoration: "none",
    fontSize: "0.9rem",
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor: "pointer",
  },
  closeBtn: (props: any) => ({
    position: "absolute",
    top: props.matches ? "1rem" : "1rem",
    right: props.matches ? "1rem" : "0.5rem",
    border: "none",
    backgroundColor: "unset",
    cursor: "pointer",
  }),
}));

export default useStyles;
